<template>
  <div style="margin: 0 24px;">
<!--    <div class="dialog-button">-->
<!--      <div v-if="isSuper == 0">-->
<!--        <label>可见时间：</label>-->
<!--        <el-select v-model="sysTime" value-key="value" placeholder="请选择"  style="width: 6em;">-->
<!--          <el-option v-for="item in sysTimeList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </div>-->
<!--      <div>-->
<!--        <label>积分/金币：</label>-->
<!--        <el-select v-model="operateGold" value-key="value" placeholder="请选择"  style="width: 7.4em;">-->
<!--          <el-option v-for="item in operateGoldList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </div>-->
<!--      <div>-->
<!--        <label>信息审核：</label>-->
<!--        <el-select v-model="operateResume" value-key="value" placeholder="请选择"  style="width: 7.4em;">-->
<!--          <el-option v-for="item in operateResumeList" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </div>-->
<!--      <div>-->
<!--        <el-button type="primary" @click="submit()">提交</el-button>-->
<!--      </div>-->
<!--    </div>-->
    <div style="display: flex;margin-bottom: 16px;flex-wrap: wrap">
      <div style="width: 50%; margin-bottom: 12px;">
        <label>客户回访：</label>
        <el-select v-model="visitState" value-key="value" placeholder="请选择"  style="width: 14em;" :disabled="(operateStateUser & 2) != 2 && userName != 'root'">
          <el-option v-for="item in visitStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%; margin-bottom: 12px;">
        <label>商品库存：</label>
        <el-select v-model="stockState" value-key="value" placeholder="请选择"  style="width: 14em;" :disabled="(operateStateUser & 4) != 4 && userName != 'root'">
          <el-option v-for="item in stockStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%; margin-bottom: 12px;">
        <label>微信绑定：</label>
        <el-select v-model="wechatState" value-key="value" placeholder="请选择"  style="width: 14em;" :disabled="(operateStateUser & 8) != 8 && userName != 'root'">
          <el-option v-for="item in wechatStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%; margin-bottom: 12px;">
        <label>预约状态：</label>
        <el-select v-model="bookState" value-key="value" placeholder="请选择"  style="width: 14em;" :disabled="(operateStateUser & 16) != 16 && userName != 'root'">
          <el-option v-for="item in bookStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%; margin-bottom: 12px;" >
        <label>卫生审核：</label>
        <el-select v-model="hygieneState" value-key="value" placeholder="请选择"  style="width: 14em;" :disabled="(operateStateUser & 32) != 32 && userName != 'root'">
          <el-option v-for="item in hygieneStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%; margin-bottom: 12px;">
        <label>上传卫生照片：</label>
        <el-select v-model="hygieneImgState" value-key="value" placeholder="请选择"  style="width: 14em;" :disabled="(operateStateUser & 64) != 64 && userName != 'root'">
          <el-option v-for="item in hygieneImgStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%; margin-bottom: 12px;">
        <label>编辑消费单：</label>
        <el-select v-model="editBookState" value-key="value" placeholder="请选择"  style="width: 14em;" :disabled="(operateStateUser & 128) != 128 && userName != 'root'">
          <el-option v-for="item in editBookStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%; margin-bottom: 12px;">
        <label>编辑充值记录：</label>
        <el-select v-model="editRechargeState" value-key="value" placeholder="请选择"  style="width: 14em;" :disabled="(operateStateUser & 256) != 256 && userName != 'root'">
          <el-option v-for="item in editRechargeStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%">
        <label>打款状态：</label>
        <el-select v-model="editPaymentState" value-key="value" placeholder="请选择"  style="width: 14em;" :disabled="(operateStateUser & 512) != 512 && userName != 'root'">
          <el-option v-for="item in editPaymentStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="width: 50%; margin-bottom: 12px;">
        <label>赠送金额限制：</label>
        <el-select v-model="editGiveNumState" value-key="value" placeholder="请选择"  style="width: 14em;" :disabled="(operateStateUser & 1024) != 1024 && userName != 'root'">
          <el-option v-for="item in editGiveNumStateList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="dialog-main">
      <div class="dialog-main-tiem">
        <div class="item-title">
          <p>管理目录</p>
          <div>
            <el-button type="text" @click="allChecked">全选</el-button>
            <el-button type="text" @click="notChecked">全不选</el-button>
          </div>
        </div>
        <el-scrollbar max-height="500px">
          <el-tree default-expand-all :data="dataArray" show-checkbox node-key="id" ref="tree" :default-checked-keys="defaultChecked" :props="defaultProps" style="line-height: 26px;"></el-tree>
        </el-scrollbar>
      </div>
<!--      <div class="dialog-main-tiem item-last">-->
<!--        <div class="item-title">-->
<!--          <p>对应渠道</p>-->
<!--          <div>-->
<!--            <el-button type="text" @click="allChannelChecked">全选</el-button>-->
<!--            <el-button type="text" @click="notChannelChecked">全不选</el-button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="item-title-tips">注：“全不选”代表无渠道限制，可看到所有数据</div>-->
<!--        <el-scrollbar max-height="500px">-->
<!--          <el-tree :data="channelArray" show-checkbox node-key="id" ref="channelTree" :default-checked-keys="defaultChannelChecked" :props="defaultChannelProps" style="line-height: 26px;"></el-tree>-->
<!--        </el-scrollbar>-->
<!--      </div>-->
    </div>
    <div class="dialog-footer" style="text-align: center; margin: 8px 0;">
      <el-button @click="cancel" >取消</el-button>
      <el-button type="primary" @click="submit">提交</el-button>
    </div>
  </div>

</template>

<script>
import {postJson, postFormData, getFormData} from "@/api/api"
import { menuList, updateSysModel, updatePermission, getAllChannelPackageList } from "@/api/url";

export default {
name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
   return {
     userModelForm: this.value.userModelForm,

     // operateState:0,
     visitState: 0,
     visitStateList: [
       {label:'无审核权限', value: 0},
       {label:'有审核权限', value: 2}
     ],

     stockState: 0,
     stockStateList: [
       {label:'不可修改库存', value: 0},
       {label:'可修改库存', value: 4}
     ],

     wechatState: 0,
     wechatStateList: [
       {label:'不可解除绑定', value: 0},
       {label:'可解除绑定', value: 8}
     ],

     bookState: 0,
     bookStateList: [
       {label:'不可修改预约状态', value: 0},
       {label:'可修改预约状态', value: 16}
     ],

     hygieneState: 0,
     hygieneStateList: [
       {label:'无审核权限', value: 0},
       {label:'有审核权限', value: 32}
     ],

     hygieneImgState: 0,
     hygieneImgStateList: [
       {label:'不可上传卫生照片', value: 0},
       {label:'可上传卫生照片', value: 64}
     ],

     editBookState: 0,
     editBookStateList: [
       {label:'有时间限制', value: 0},
       {label:'无时间限制', value: 128}
     ],

     editRechargeState: 0,
     editRechargeStateList: [
       {label:'有时间限制', value: 0},
       {label:'无时间限制', value: 256}
     ],

     editPaymentState: 0,
     editPaymentStateList: [
       {label:'不可修改', value: 0},
       {label:'可修改', value: 512}
     ],

     editGiveNumState: 0,
     editGiveNumStateList: [
       {label:'有限制', value: 0},
       {label:'没有限制', value: 1024}
     ],

     //管理目录
     dataArray: [],
     defaultProps: {
       children: 'children',
       label: 'name'
     },
     defaultChecked:[],

     //渠道包名
     channelArray: [],
     defaultChannelProps: {
       children: 'channelList',
       label: 'name'
     },
     defaultChannelChecked:[],

     // operateState: this.value.userModelForm.operateState,
     //
     // operateGoldList: [
     //   {label: '不可操作', value: 0},
     //   {label: '可操作', value: 2},
     // ],
     // operateGold: this.value.userModelForm.operateState == 0?0:this.value.userModelForm.operateState == 2?2:this.value.userModelForm.operateState == 4?0:this.value.userModelForm.operateState == 6?2:0,
     //
     // operateResumeList: [
     //   {label: '不可操作', value: 0},
     //   {label: '可操作', value: 4},
     // ],
     // operateResume: this.value.userModelForm.operateState == 0?0:this.value.userModelForm.operateState == 2?0:this.value.userModelForm.operateState == 4?4:this.value.userModelForm.operateState == 6?4:0,

     sysTimeList: [
       {label: '不限', value: 0},
       {label: '1个月', value: 1},
       {label: '2个月', value: 2},
       {label: '3个月', value: 3},
       {label: '6个月', value: 6},
       {label: '1年', value: 12},
       {label: '2年', value: 24},
     ],
     sysTime: 0,
     isSuper: 0,

     operateStateUser: JSON.parse(sessionStorage.getItem('operateState')),
     userName: JSON.parse(sessionStorage.getItem('account'))

   }
  },

  computed: {
    operateState() {
      return this.visitState + this.stockState + this.wechatState + this.bookState + this.hygieneState + this.hygieneImgState + this.editBookState + this.editRechargeState + this.editPaymentState + this.editGiveNumState
    }
  },

  methods: {
    cancel() {
      this.$emit("close");
    },
    notChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    allChecked() {
      this.$refs.tree.setCheckedNodes(this.dataArray);
    },

    notChannelChecked() {
      this.$refs.channelTree.setCheckedKeys([]);
    },
    allChannelChecked() {
      this.$refs.channelTree.setCheckedNodes(this.channelArray);
    },

    submit() {
      let _this = this;
      let checkIds = this.getChecked();
      // let channelCheckIds = this.getChannelChecked()
      let param = {}
      param['id'] = this.userModelForm.id;
      param['menuIdArr'] = checkIds;
      param['operateState'] = this.operateState;
      // param['channelIds'] = channelCheckIds.toString();
      // param['duration'] = this.sysTime;
      // param['operateState'] = this.operateGold + this.operateResume;
      postFormData(updatePermission, param).then((data) => {
        let { code, msg } = data;
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          _this.$emit('confirm')
        } else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: '获取失败',
            type: 'warning'
          })
        }
      })
    },

    //获取管理员权限
    getRootMenuList(account) {
      let _this = this;
      getFormData(menuList, {}).then((data) => {
        let code = data.code;
        if(code == 200) {
          _this.dataArray = this.formatList(data.data, 0);
          // console.log(_this.dataArray)
          let ids = [];
          if(account.sysMenuList) {
            account.sysMenuList.map(item => {
              ids.push(item.id)
            })
          }
          _this.defaultChecked = _this.getDefaultChecked(ids, _this.dataArray);
          // _this.account = account;
        } else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: '获取失败',
            type: 'warning'
          })
        }
      })
    },

    getMenuList(account) {
      console.log(account)
      if(account.account == 'root') {
        this.getRootMenuList(account)
      }else {
        let ids = []
        if(this.userModelForm.sysMenuList) {
          this.userModelForm.sysMenuList.map(item => {
            ids.push(item.id)
          })
        }
        this.dataArray = JSON.parse(localStorage.getItem('menuList'));
        this.defaultChecked = this.getDefaultChecked(ids, this.dataArray);
      }
    },

    formatList(list, preId) {
      let array = [];
      let _this = this;
      list.forEach(function(e) {
        if(e['preId'] == preId) {
          let children = _this.formatList(list, e['id']);
          if(children.length > 0) {
            e['children'] = children;
          }
          array.push(e);
        }
      });
      return array;
    },
    //获取默认选项
    getDefaultChecked(array, dataArray) {
      let ids = array;
      for(let i = array.length-1; i >= 0; i--) {
        dataArray.forEach((e) => {
          if(e.id == array[i] && e.children != null) {
            ids = this.getDefaultChecked(array, e.children);
            ids.splice(i, 1);
          }
        })
      }
      return ids;
    },
    //获取提交参数
    getChecked() {
      let idArray = [];
      let array = this.$refs.tree.getCheckedNodes();
      // console.log(array)
      array.forEach((e) => {
        idArray = idArray.concat(e.id);
        idArray = idArray.concat(this.getParentChecked(e))
      });
      return idArray;
    },
    //提交时获取父级的id
    getParentChecked(el) {
      let array = [];
      if(el.level > 2) {
        array = array.concat(el.preId);
        this.dataArray.forEach((e) => {
          if(e.id == el.preId) {
            array = array.concat(this.getParentChecked(e));
          }
        })
      } else if(el.level == 2) {
        array = array.concat(el.preId);
      }
      return array;
    },


    //包名渠道列表
    // getChannelPackageList(account) {
    //   getFormData(getAllChannelPackageList).then((data) => {
    //     let {msg, code} = data;
    //     if (code == 200) {
    //       let dataList = data.data;
    //       // console.log(dataList)
    //       for (let i=0; i<dataList.length; i++) {
    //         dataList[i].name = dataList[i].packageName;
    //         for (let j=0; j<dataList[i].channelList.length; j++) {
    //           dataList[i].channelList[j].name = dataList[i].channelList[j].channel
    //         }
    //       }
    //       this.channelArray = dataList
    //       let ids = [];
    //       if(account.channelIds) {
    //         ids = account.channelIds.split(",");
    //       }
    //       this.defaultChannelChecked = ids
    //     }else {
    //       this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: msg,
    //         type: 'warning'
    //       })
    //     }
    //   })
    // },

    getChannelChecked() {
      let idArray = [];
      let array = this.$refs.channelTree.getCheckedNodes();
      array.forEach((e) => {
        if (!e.channelList) {
          idArray.push(e.id)
        }
      })
      return idArray
    }

  },
  mounted() {
    this.getMenuList(this.userModelForm)
    // this.getChannelPackageList(this.userModelForm)
    // switch (this.userModelForm.operateState) {
    //   case 0:
    //     this.visitState = 0
    //     this.stockState = 0
    //     break;
    //   case 2:
    //     this.visitState = 2
    //     this.stockState = 0
    //     break;
    //   case 4:
    //     this.visitState = 0
    //     this.stockState = 4
    //     break;
    //   case 6:
    //     this.visitState = 2
    //     this.stockState = 4
    //     break;
    // }
    this.visitState = this.userModelForm.operateState & 2
    this.stockState = this.userModelForm.operateState & 4
    this.wechatState = this.userModelForm.operateState & 8
    this.bookState = this.userModelForm.operateState & 16
    this.hygieneState = this.userModelForm.operateState & 32
    this.hygieneImgState = this.userModelForm.operateState & 64
    this.editBookState = this.userModelForm.operateState & 128
    this.editRechargeState = this.userModelForm.operateState & 256
    this.editPaymentState = this.userModelForm.operateState & 512
    this.editGiveNumState = this.userModelForm.operateState & 1024
  }
}
</script>

<style scoped>
.dialog-button {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item-title-tips {
  font-size: 12px;
  color: #aaaaaa;
  margin-bottom: 12px;
}

.dialog-main {
  display: flex;
  justify-content: space-between;
}


.item-title p {
  font-weight: bold;
  color: #222222;
}

.dialog-main-tiem {
  border: #ededed 1px solid;
  padding: 16px 24px;
  width: 100%;
  margin-right: 16px;
}

.item-last {
  margin-right: 0;
}

</style>
